import { LogOut } from 'lucide-react';
import { useAuth } from '@/features/auth/use-auth';
import { Button } from '@/components/ui/button';

/**
 * Topbar: tenant + user identity on the left, actions on the right.
 * Phase 0: tenant id is shown raw; Phase 1 we'll fetch tenant.name and
 * show that. Notifications, search, theme toggle land later when needed.
 */
export function Topbar() {
  const { user, logout } = useAuth();
  if (!user) return null;

  return (
    <header className="flex h-16 shrink-0 items-center justify-between border-b border-border-subtle bg-surface-card px-6">
      <div className="flex flex-col">
        <span className="text-xs uppercase tracking-widest text-ink-500">Entreprise</span>
        <span className="text-sm font-medium text-ink-800">
          {user.tenantId ? `Tenant ${user.tenantId.slice(0, 8)}…` : 'Plateforme Fellwin'}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <div className="text-right">
          <div className="text-sm font-medium text-ink-800">{user.name}</div>
          <div className="text-xs text-ink-500 capitalize">{user.role}</div>
        </div>
        <Button variant="ghost" size="icon" onClick={logout} aria-label="Se déconnecter">
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
